import {styled} from '@innowise-group/ui-kit';

export const LocationFieldForm = styled.div`
  width: 50%;
`;
